import React from 'react';
import { useAuth } from '../../context/AuthContext';

const LogoutButton = () => {
  const { logout, user } = useAuth();

  return (
    <div className="flex items-center space-x-4">
      <span className="text-sm text-gray-600">Welcome, {user?.name}</span>
      <button
        onClick={logout}
        className="text-red-600 hover:text-red-800 text-sm font-medium"
      >
        Logout
      </button>
    </div>
  );
};

// Online Sales Modal Component - SEPARATE SYSTEM

export default LogoutButton;
